module.exports = __webpack_public_path__ + "img/Must be an Agent to Register_en.3e0280b.png";